module.exports = __webpack_public_path__ + "img/step3-en.91965e62.png";